module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chap-title"
  }, [_c('span', [_vm._v("AUTHOR’S NOTE")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("The publication of this third novel in the Drury Lane trilogy makes a brief word of explanation necessary.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The cases entitled "), _c('i', [_vm._v("The Tragedy of X")]), _vm._v(" and "), _c('i', [_vm._v("The Tragedy of Y")]), _vm._v(" occurred very close to each other in point of time. But "), _c('i', [_vm._v("The Tragedy of Z")]), _vm._v(" took ten years in the making. By that I mean that a full decade elapsed before a problem arose which made possible a title consistent with the titles of the first two.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the intervening period Drury Lane solved many strange and perplexing cases, the most interesting of which will be recorded at some future time.")]), _vm._v(" "), _c('p', {
    staticClass: "righta"
  }, [_c('span', [_vm._v("E"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LLERY")]), _vm._v(" Q"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UEEN")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45dff8ee","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/fm01.vue
// module id = 72
// module chunks = 0